/*
 * @Author: 前端 qianduan01@didihu.com.cn
 * @Date: 2024-09-14 09:53:36
 * @LastEditors: 前端 qianduan01@didihu.com.cn
 * @LastEditTime: 2024-09-24 10:17:35
 * @FilePath: \dj-car-life-system\src\store\modules\d2admin\modules\merchant.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getListShop4sByRef } from "@api/contentManager"
export default {
  namespaced: true,
  state: {
    // 门店号列表
    merchantIdList: []
  },
  mutations: {
    set(state, list) {
      state.merchantIdList = list
    }
  },
  actions: {
    getMerchantIdList({ commit }) {
      return getListShop4sByRef({
        currentPage: 1,
        pageSize: 2000,
        scene: 1
      }).then((res) => {
        commit("set", res)
      })
    }
  }
}
